<template>
  <DialogTemplate>
    <div
      class="py-2 px-2"
      style="max-width: 520px"
    >
      <div class="text-large weight_700 clr-primary">
        {{ $t('tabs.blockers') }}
      </div>
      <div class="weight_500 mb-4 clr-grey">
        {{ $t('blockers.title_sub') }}
      </div>

      <div class="weight_600 f-center mt-6">
        <div class="mr-auto">
          {{ $t('blockers.blockers_tab') }}
        </div>
      </div>

      <div
        v-for="(item, index) in textsBlockers"
        :key="index + 'dd'"
        class="mt-2 ml-4"
      >
        <div
          class="weight_400 text-medium clr-grey mt-1"
          v-html="item.sub"
        ></div>
        <div
          v-if="item.examples"
          class="text-italic text-small bl-grey_2s px-2s pr-6 my-2 clr-grey"
        >
          <div class="weight_600 mb-1">{{ $t('common.examples_is') }}</div>
          <ul
            class="f-column"
            style="gap: 0.25rem"
          >
            <li v-html="item.examples[0]"></li>
            <li v-html="item.examples[1]"></li>
          </ul>
        </div>
      </div>

      <div class="weight_600 f-center mt-6">
        <div class="mr-auto">
          {{ $t('common.summary_tab') }}
        </div>
      </div>

      <div
        v-for="(item, index) in texts"
        :key="index + 'cc'"
        class="mt-2 ml-4"
      >
        <div class="weight_600 f-center">
          <div
            v-if="item.icon"
            :class="item.icon"
            class="mr-2"
          ></div>
          <div class="mr-auto">
            {{ item.title }}
          </div>
        </div>
        <div
          class="weight_400 text-medium clr-grey mt-1"
          v-html="item.sub"
        ></div>
      </div>
    </div>
    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'BlockersTipsDialog',
  components: {
    DialogTemplate,
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'blockers-tips-dialog')
    },
  },
  computed: {
    textsBlockers() {
      return [
        {
          sub: this.$t('blockers.blockers_tab_sub'),
          examples: [
            this.$t('blockers.blockers_examples_1'),
            this.$t('blockers.blockers_examples_2'),
          ],
        },
      ]
    },
    texts() {
      const iconsBlocker = {
        min_icon:
          '<span class="gw-icon-blocker-big gw-icon_inline" style="font-size: 1.25rem;position:relative;top:0.075rem;color:var(--clr-eveqeqrbl-10)"></span>',
        max_icon:
          '<span class="gw-icon-blocker-big gw-icon_inline" style="font-size:1.25rem;position:relative;top:0.075rem;color:var(--clr-eveqeqrbl100)"></span>',
      }
      const iconsUnblocker = {
        min_icon:
          '<span class="gw-icon-unblocker-big gw-icon_inline" style="font-size: 1.25rem;position:relative;top:0.075rem;color:var(--clr-eveqeqrbl-10)"></span>',
        max_icon:
          '<span class="gw-icon-unblocker-big gw-icon_inline" style="font-size: 1.25rem;position:relative;top:0.075rem;color:var(--clr-eveqeqrbl100)"></span>',
      }
      return [
        {
          title: this.$t('blockers.value_removal'),
          icon: 'mdi-custom gw-icon-blocker-big',
          sub: this.$t('blockers.value_removal_sub', iconsBlocker),
        },
        {
          title: this.$t('blockers.trash_removal'),
          icon: 'mdi-custom gw-icon-unblocker-big',
          sub: this.$t('blockers.trash_removal_sub', iconsUnblocker),
        },
      ]
    },
  },
}
</script>
